import localDB from "./localDB";

let GLOBAL = require('./globals');

const ProductImageData = {
    async list(pk) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/product-images/${pk}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async delete(pk, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-image/${pk}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async add(pk, file, res) {
        let data = new FormData();
        data.append("file", file);
        await fetch(`${GLOBAL.BASE_URL}api/product-image/${pk}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            'dataType': 'json',
            body: JSON.stringify(file)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    }
};

export default ProductImageData;



// WEBPACK FOOTER //
// ./src/data/ProductImageData.js